<template>
    <div>
        <router-link to="/" class="underline">
            &laquo; Back to Main Menu
        </router-link>

        <br><br>

        <ul class="node" type="headline" level="1">
            <li>
                <div class="node-value">
                    <span class="prefix"><span>*</span></span>
                    <span class="value"> Upload a File</span>
                </div>
            </li>
        </ul>

        <br>

        <div class="node-content highlight">Your information is only saved in this browser.</div>

        <br>

        <form class="sftp">
            <div class="field">
                <label>Select:</label>
                <input type="file" @change="app.upload">
            </div>

            <div class="field node" type="headline">
                <button class="no-button">
                    <mark class="done">
                        Upload &raquo;
                    </mark>
                </button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    props: ['app']
};
</script>
